'use client';
import { useEffect, useRef, useState } from 'react';

export const ArticleView = ({ title, content }: { title?: string; content: string }) => {
  const [clientRenderedContent, setClientRenderedContent] = useState<string | null>(null);
  const articleRef = useRef<HTMLDivElement | null>(null);

  const updateScrollbarVisibility = (tbWrap: HTMLElement) => {
    if (!tbWrap) return;

    const tableElement = tbWrap.firstElementChild as HTMLElement;
    const { scrollLeft } = tbWrap;
    const maxScrollLeft = tableElement.offsetWidth - tbWrap.clientWidth;

    tbWrap.parentElement?.classList.toggle('left-shadow', scrollLeft > 0);
    tbWrap.parentElement?.classList.toggle('right-shadow', scrollLeft < maxScrollLeft - 1);
  };

  useEffect(() => {
    // 콘텐츠를 업데이트하고 변환을 적용합니다.
    if (content) {
      const updatedContent = content
        .replace(/(\\s?)\w+/g, '')
        .replace(/(<table[\s\S]*?>)/g, '<div class="table-container"><div class="table-wrap"><table>')
        .replace(/(<\s?\/\s?table>)/g, '</table></div></div>');

      setClientRenderedContent(updatedContent);
    }
  }, [content]); // content가 변경될 때마다 업데이트

  useEffect(() => {
    const handleScroll = (event: Event) => {
      const tbWrap = event.currentTarget as HTMLElement;
      updateScrollbarVisibility(tbWrap);
    };

    const handleResize = () => {
      if (articleRef.current) {
        articleRef.current.querySelectorAll('.table-wrap').forEach((tbWrap) => {
          updateScrollbarVisibility(tbWrap as HTMLElement);
        });
      }
    };

    if (articleRef.current) {
      articleRef.current.querySelectorAll('.table-wrap').forEach((tbWrap) => {
        tbWrap.addEventListener('scroll', handleScroll);
        updateScrollbarVisibility(tbWrap as HTMLElement);
      });
    }

    // 초기 렌더링 후 한 번 크기 조정 처리를 실행합니다.
    window.addEventListener('resize', handleResize);
    handleResize();

    // 컴포넌트가 언마운트되거나 콘텐츠가 변경될 때 이벤트 리스너를 정리합니다.
    return () => {
      if (articleRef.current) {
        articleRef.current.querySelectorAll('.table-wrap').forEach((tbWrap) => {
          tbWrap.removeEventListener('scroll', handleScroll);
        });
      }
      window.removeEventListener('resize', handleResize);
    };
  }, [clientRenderedContent]); // clientRenderedContent가 변경될 때마다 재실행

  return (
    <article ref={articleRef} className="w-full pb-24 compact:pt-6 pt-12">
      {title && (
        <h1
          style={{
            fontSize: 'calc(32px + (8 * (100vw - 280px) / 920))',
            fontWeight: 700,
            letterSpacing: '-.05rem',
            marginTop: '2.5rem',
            marginBottom: '4rem',
            lineHeight: '1.325'
          }}
        >
          {title}
        </h1>
      )}
      {/* 동적으로 업데이트된 콘텐츠를 렌더링합니다. */}
      {clientRenderedContent && <div className="prose" dangerouslySetInnerHTML={{ __html: clientRenderedContent }} />}
    </article>
  );
};
